import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Mensajes de correo',
  labels: {
    view_full_message: 'Ver mensaje completo',
    status: 'Estado:',
    on: 'Activo',
    off: 'Inactivo',
  },
  tiles: {
    sends_count: 'Mensajes enviados',
    delivery_rate: 'Tasa de entrega',
    delivered_suffix: 'entregados',
    open_rate: 'Tasa de apertura',
    opened_suffix: 'abiertos',
    click_rate: 'Tasa de clics',
    clicked_suffix: 'clicados',
    spam_report_rate: 'Tasa de spam',
    spam_reports_suffix: 'reportes',
    unsubscribe_rate: 'Tasa de bajas',
    unsubscribes_suffix: 'bajas',
  },
  toasts: {
    failed_to_update_status: 'Error al actualizar el estado',
    failed_to_load_data: 'Error al cargar datos',
  },

  preview_modal: {
    title: 'Vista previa de plantilla',
    labels: {
      subject: 'Asunto:',
      close: 'Cerrar',
    },
    toasts: {
      failed_to_load_data: 'Error al cargar los datos de vista previa',
    },
    template_data: {
      recipient_name: '&lt;Nombre&gt;',
    },
  },
};
